export default __webpack_public_path__ + "static/media/event-prop-4.985a4534.png";